import script from "./CompanyMiniature.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyMiniature.vue?vue&type=script&setup=true&lang=js"

import "./CompanyMiniature.vue?vue&type=style&index=0&id=44fe9c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44fe9c8a"]])

export default __exports__